import { PassengerDataMapper } from '@app/mappers/micro/passenger-data.mapper';
import { GetPassengerDataResponseInt } from '@app/interfaces/micro/passenger-data.interface';
import { Passenger } from '@app/models/micro/passenger.model';
import { StatusBag } from '@app/enums';

/** Atributos de AVAILABLE_LUGGAGE por pasajero */
export interface AvailableLuggageNewRelicPayload {
  passenger_id: string | null;
  pay_redeemed_bags: number;
  include_bags: number;
  checked_bags: number;
  available_bags: number;
}

export interface AvailableLuggageReservationNewRelicPayload {
  included_bags: number;
  paid_bags: number;
  redeemed_bags: number;
  available_bags: number;
  selected_passengers: number;
}

const REDEEMED_STATUSES: StatusBag[] = [StatusBag.REDEEMED, StatusBag.REDEEMED_APPLIED];

export class AvailableLuggageMetrics {
  static buildPayload(
    passenger: Passenger,
    includeBagsAdt: number,
    passengerDataResponse: GetPassengerDataResponseInt | null
  ): AvailableLuggageNewRelicPayload {
    const payRedeemedBags = passenger.ancillaries?.length ?? 0;
    const includeBags = includeBagsAdt ?? 0;
    const checkedBags = passengerDataResponse
      ? PassengerDataMapper.getDocumentedBagsCount(passengerDataResponse, passenger.nameRefNumber)
      : 0;
    const availableBags = payRedeemedBags + includeBags - checkedBags;

    return {
      passenger_id: passenger.nameRefNumber ?? passenger.id ?? null,
      pay_redeemed_bags: payRedeemedBags,
      include_bags: includeBags,
      checked_bags: checkedBags,
      available_bags: availableBags,
    };
  }

  static buildReservationPayload(
    passengers: Passenger[],
    selectedPassengersCount: number
  ): AvailableLuggageReservationNewRelicPayload {
    let includedBags = 0;
    let paidBags = 0;
    let redeemedBags = 0;

    for (const passenger of passengers) {
      const bags = passenger.bagStack ?? [];
      for (const bag of bags) {
        if (bag.used) {
          continue;
        }
        if (bag.status === StatusBag.INCLUDE) {
          includedBags++;
        } else if (bag.status === StatusBag.PAID) {
          paidBags++;
        } else if (REDEEMED_STATUSES.includes(bag.status as StatusBag)) {
          redeemedBags++;
        }
      }
    }

    return {
      included_bags: includedBags,
      paid_bags: paidBags,
      redeemed_bags: redeemedBags,
      available_bags: includedBags + paidBags + redeemedBags,
      selected_passengers: selectedPassengersCount,
    };
  }
}
